'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { getENV, useEffectOnce, useLoyaltyContext, usePageLayout, useStore } from '@libs/common-next';
import { gtmConfig } from '../../constants/config';
import { trackUserAuthentication } from '../../gtm';
import { PageViewTracking } from '../PageViewTracking';
export function NoScriptIframe() {
  const $ = _c(1);
  const {
    gtmAuth,
    gtmPreview,
    gtmContainerId
  } = gtmConfig[getENV("NEXT_PUBLIC_LOCALE") == "en-CA" ? "ca" : "us"];
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <noscript><iframe title="gtm-noscript" src={`https://www.googletagmanager.com/ns.html?id=${gtmContainerId}&gtm_auth=${gtmAuth}&gtm_preview=${gtmPreview}&gtm_cookies_win=x`} height="0" width="0" style={{
        display: "none",
        visibility: "hidden"
      }} /></noscript>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function GtmPageViewTracker() {
  const $ = _c(16);
  const {
    isAuthenticated,
    user,
    userData
  } = usePageLayout();
  const {
    memberPoints
  } = useLoyaltyContext();
  const shouldTriggerUserAuthenticationEventRef = useRef(true);
  const {
    selectedStoreId
  } = useStore();
  let t0;
  if ($[0] !== isAuthenticated || $[1] !== memberPoints || $[2] !== selectedStoreId || $[3] !== user?.loyaltyid || $[4] !== userData) {
    t0 = () => {
      if (isAuthenticated === "velocity" && memberPoints && userData?.profile && shouldTriggerUserAuthenticationEventRef.current) {
        trackUserAuthentication({
          loyaltyId: user?.loyaltyid?.toString() ?? "",
          storeId: selectedStoreId ?? userData.profile.storeNumber ?? null,
          totalTreatsPoints: memberPoints?.availablePoints ?? 0,
          loginState: true
        });
        shouldTriggerUserAuthenticationEventRef.current = false;
      }
    };
    $[0] = isAuthenticated;
    $[1] = memberPoints;
    $[2] = selectedStoreId;
    $[3] = user?.loyaltyid;
    $[4] = userData;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] !== isAuthenticated || $[7] !== memberPoints || $[8] !== selectedStoreId || $[9] !== user || $[10] !== userData) {
    t1 = [isAuthenticated, memberPoints, user, userData, selectedStoreId];
    $[6] = isAuthenticated;
    $[7] = memberPoints;
    $[8] = selectedStoreId;
    $[9] = user;
    $[10] = userData;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[12] !== isAuthenticated) {
    t2 = () => {
      if (!isAuthenticated) {
        shouldTriggerUserAuthenticationEventRef.current = true;
      }
    };
    t3 = [isAuthenticated];
    $[12] = isAuthenticated;
    $[13] = t2;
    $[14] = t3;
  } else {
    t2 = $[13];
    t3 = $[14];
  }
  useEffect(t2, t3);
  useEffectOnce(_temp);
  let t4;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <><NoScriptIframe /><PageViewTracking /></>;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}
function _temp() {
  window.flags = {
    ...window.flags,
    IS_PERFORMANCE_MODE: process.env.NEXT_PUBLIC_PERFORMANCE_MODE === "true"
  };
}